import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestAutoComponent } from './request-auto.component';
import { RequestAutoRoutingModule } from './request-auto-routing.module';
import { RequestsSharedModule } from '../@shared';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexModule } from '@angular/flex-layout';
import { RequestAutosStore } from '../@shared/request-data-autos/request-data-autos.store';

@NgModule({
  declarations: [RequestAutoComponent],
  imports: [CommonModule, MaterialModule, RequestAutoRoutingModule, RequestsSharedModule, TranslateModule, FlexModule],
  providers: [RequestAutosStore],
  exports: [RequestAutoComponent],
})
export class RequestAutoModule {}
